import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { notify } from "../../utils/utils";
import { UserContext } from "../../context/provider/UserProvider";

const urlBaseReportes = process.env.REACT_APP_TMAN_API + '/Report'

export const useReportes = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa
    
    const [reportesActivos,setReportesActivos] = useState([])

    //RP001
    const [datosRP001,setDatosRP001] = useState({
        repuestos: [],
    })

    
    const listarReportesActivos = async  () => {
        const response = await AuthFetch({
            url: urlBaseReportes + '?' + new URLSearchParams({
                CodEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setReportesActivos(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const funcionesRP001 = {
        listarReporteRepuestos: async () => {
            const response = await AuthFetch({
                url: urlBaseReportes + '/services?' + new URLSearchParams({
                    CodEmpresa: codEmpresa
                })
            })
            if(response.isValid){
                setDatosRP001((valorAnterior) => {
                    return {
                        ...valorAnterior,
                        repuestos: response.content
                    }
                })
            }else{
                notify(response.exceptions[0].description,'error')
            }
        }
    }
    
    return {
        listarReportesActivos,
        reportesActivos,
        funcionesRP001,
        datosRP001
    }
};
